import React, { useContext, useEffect, useState } from 'react'
import { MenuItem, Select } from '@mui/material'
import { EmploymentsContext } from '../contexts/EmploymentsContext'
import { useHistory } from 'react-router-dom'
import { changeSelectedStore } from '../Utilities/authenticationService'
import { isMobile } from '../Utilities/isMobile'

const SelectedStore = ({ disabled }) => {
    const selectedEmploymentId = parseInt(localStorage.selected_emp)
    const { userEmployments, canEditShiftFor, isManagerFor } = useContext(EmploymentsContext)
    const [selectedStore, setSelectedStore] = useState()
    const history = useHistory()

    useEffect(() => {
        if (!userEmployments) return
        setSelectedStore(
            userEmployments.find(employment => employment.id === selectedEmploymentId) || userEmployments[0]
        )
    }, [userEmployments])

    const handleChange = e => {
        setSelectedStore(userEmployments.find(employment => employment.id === e.target.value))
        changeSelectedStore(e.target.value)
        history.replace(history.location.pathname.replace(`${selectedEmploymentId}`, `${e.target.value}`))
    }

    const disableOption = employment => {
        if (!history.location.pathname.includes('/createshift')) return false
        if (canEditShiftFor[employment.id] || isManagerFor[employment.id]) return false
        return true
    }

    if (selectedStore)
        return (
            <div
                style={{
                    margin: '.5rem',
                    background: 'rgba(0, 0, 0, .04)',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    width: isMobile() ? '60%' : 'auto'
                }}
            >
                <Select
                    disabled={disabled}
                    size="small"
                    sx={{ border: 'none', mx: 'auto' }}
                    fullWidth
                    defaultValue=""
                    value={selectedStore.id} // really doesn't like objects as values
                    onChange={handleChange}
                >
                    {userEmployments.map(employment => (
                        <MenuItem
                            value={employment.id}
                            key={employment.id}
                            disabled={disableOption(employment)}
                            sx={{
                                background: 'rgba(0, 0, 0, .04)'
                            }}
                        >
                            <div style={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }}>
                                {employment?.store?.name}
                            </div>
                        </MenuItem>
                    ))}
                </Select>
            </div>
        )
    return <></>
}

export default SelectedStore
